import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.2" }, [
      _createElementVNode("path", {
        d: "M13.8684 12L17.0522 8.8892C17.2634 8.6828 17.382 8.40285 17.382 8.11095C17.382 7.81905 17.2634 7.5391 17.0522 7.3327C16.841 7.1263 16.5546 7.01034 16.256 7.01034C15.9573 7.01034 15.6709 7.1263 15.4597 7.3327L12.2771 10.4446L9.09441 7.3327C8.88323 7.1263 8.59682 7.01034 8.29818 7.01034C7.99953 7.01034 7.71312 7.1263 7.50195 7.3327C7.29078 7.5391 7.17214 7.81905 7.17214 8.11095C7.17214 8.40285 7.29078 8.6828 7.50195 8.8892L10.6857 12L7.50195 15.1108C7.29078 15.3172 7.17214 15.5971 7.17214 15.889C7.17214 16.181 7.29078 16.4609 7.50195 16.6673C7.71312 16.8737 7.99953 16.9897 8.29818 16.9897C8.59682 16.9897 8.88323 16.8737 9.09441 16.6673L12.2771 13.5554L15.4597 16.6673C15.6709 16.8737 15.9573 16.9897 16.256 16.9897C16.5546 16.9897 16.841 16.8737 17.0522 16.6673C17.2634 16.4609 17.382 16.181 17.382 15.889C17.382 15.5971 17.2634 15.3172 17.0522 15.1108L13.8684 12ZM12.2771 23C6.06142 23 1.02295 18.0753 1.02295 12C1.02295 5.9247 6.06142 1 12.2771 1C18.4927 1 23.5312 5.9247 23.5312 12C23.5312 18.0753 18.4927 23 12.2771 23Z",
        fill: "#1D2522"
      })
    ], -1)
  ])))
}
export default { render: render }